export default __webpack_public_path__ + "static/media/auction-winner.e6dc390f.png";